<template>
<div>
  <div class="page-header">
          <div class="row justify-content-end">
            <div class="col-10 text-left">
              <h2 class="page-title">{{$t('registration.tabs.tabITLiteracy')}}</h2>
            </div>
            <div class="col-2 lighten text-right">
              <h2 class="page-title">0%</h2>
            </div>
          </div>
        </div>
    <form class="row justify-content-center" action="POST" v-on:submit.prevent="validateLearnerCode('certificationForm')" data-vv-scope="certificationForm">
     <!-- <transition name="fade"> -->
    <div class="col-12" v-if="screenConfig.visible ">
        <div class="form-group custom-input" v-if="isVisible('certificationName')">
          <div v-if="!noneOfAbove">
            <div class="para">{{$t('candidateProfile.certification.lblCertificationCompleted')}} </div> 
            <v-select label="certificationName" :class="{'form-error': errors.has('certificationName')}" v-model="certificationDetails.itCertification" :on-change="certificationSelect(certificationDetails.itCertification)" :options.sync="certificationList" :error-messages="errors.collect('certificationName')" v-validate="'required|not_in:Select'" data-vv-name="certificationName" name="certificationName"  :placeholder="$t('candidateProfile.certification.plceHoITCertification')" required></v-select>
            <sup>
              <i class="mdi mdi-star text-danger"></i>
            </sup>
            <div v-if="noneOfAbove === false && (certificationDetails.itCertification != null && certificationDetails.itCertification != undefined)">
              <div class="para">{{$t('candidateProfile.certification.lblLearnerCodeIs')}} </div> 
              <input minlength="10" maxlength="16" oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;" name="learnercode" class="form-control-alt uppercase col-5" id="learnerCode" v-model="certificationDetails.learnerCode" v-validate="'required|numeric'" :class="{'form-error': errors.has('certificationForm.learnercode'),'input': true, 'is-danger': errors.has('certificationForm.learnercode') }" type="number" :placeholder="$t('candidateProfile.certification.plceHoLearnerCode')" v-on:keyup="learnerCodeVerified = false">
              <sup>
                <i class="mdi mdi-star text-danger"></i>
              </sup>
              <p></p>
            </div>
          </div>
          <div class="wrap-cb">
            <label class="c-wrap pad-left-35">{{$t('candidateProfile.certification.lblNotCompletedCertification')}}
            <input type="checkbox"  v-model="noneOfAbove" :value=true @change="certificationDetails.itCertification = null; certificationDetails.learnerCode = '';certificationDetails.certificationCompleted = false" id="checkIT">
            <span class="checkmark"></span>
            </label>
          </div>
        </div>
        <p></p>
        <div class="form-group custom-input col-12" v-if="isVisible('alcCode')">
          <div class="wrap-cb">
            <label class="c-wrap pad-left-35">{{$t('candidateProfile.certification.lblReferralAlc')}}
            <input type="checkbox"  v-model="referralAlc" :value=true @change="counsellor = false;certificationDetails.alcCode = ''; certificationDetails.referralCode = ''" id="referralAlc">
            <span class="checkmark"></span>
            </label>
          </div>
          <p></p>
          <div v-if="referralAlc">
            <div class="para"> {{$t('candidateProfile.certification.lblAlcCode')}}</div> 
            <input minlength="7" maxlength="10" oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;" name="alcCode" class="form-control-alt col-3" id="alcCode" v-model="certificationDetails.alcCode" v-validate="'required|numeric'" :class="{'form-error': errors.has('certificationForm.alcCode'),'input': true, 'is-danger': errors.has('certificationForm.alcCode') }" type="number" :placeholder="$t('candidateProfile.certification.plceHoAlcCode')" >
            <sup>
              <i class="mdi mdi-star text-danger"></i>
            </sup>
          </div>
        </div>
        <br/>
        <div class="form-group custom-input" v-if="isVisible('referralCode')">
          <div class="wrap-cb">
            <label class="c-wrap pad-left-35">{{$t('candidateProfile.certification.lblCounsellor')}}
            <input type="checkbox"  v-model="counsellor" :value=true @change="referralAlc = false;certificationDetails.alcCode = ''; certificationDetails.referralCode = ''" id="counsellor">
            <span class="checkmark"></span>
            </label>
          </div>
          <p></p>
          <div v-if="counsellor">
            <div class="para"> {{$t('candidateProfile.certification.lblReferralCode')}}</div> 
            <input minlength="5" maxlength="20" oninput="this.value=this.value.slice(0,this.maxLength||1/1);this.value=(this.value   < 0) ? (1/1) : this.value;" name="referralCode" class="form-control-alt uppercase" id="referralCode" v-model="certificationDetails.referralCode" v-validate="'required|alpha_num'" :class="{'form-error': errors.has('certificationForm.referralCode'),'input': true, 'is-danger': errors.has('certificationForm.referralCode') }" type="text" :placeholder="$t('candidateProfile.certification.plceCareerCounsellorCode')" >
            <sup>
              <i class="mdi mdi-star text-danger"></i>
            </sup>
          </div>
        </div>
      
    </div>
     <!-- </transition> -->
    </form>
       <div class="text-right">
        <button type="button" class="btn  btn btn-orange" @click="nextTabFunc"> {{$t('button.next')}}</button>
    </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'ITCertification',
  components: {},
  data () {
    return {
      selected: '',
      certificationList: [],
      certificationDetails: {certificationCompleted: false, itCertification: null, referralCode: ''},
      isCertified: false,
      defaultObj: {'certificationID': 0, 'certificationName': 'None Of The above'},
      learnerData: { },
      learnerCodeVerified: false,
      noneOfAbove: false,
      screenConfig: {},
      referralAlc: false,
      counsellor: false
    }
  },
  methods: {
    isVisible (fieldName) {
      for (var i in this.screenConfig.attributes) {
        if (this.screenConfig.attributes[i].name === fieldName && this.screenConfig.attributes[i].visible) {
          return true
        }
      }
    },
    nextTabFunc () {
      this.validateALCCode()
      // this.save()
    },
    validateALCCode () {
      var self = this
      if (this.referralAlc && (this.certificationDetails.alcCode === undefined || this.certificationDetails.alcCode === '')) {
        this.$toasted.error(self.$t('candidateProfile.certification.toastrErrorALCcodeRequired'))
        return false
      }
      if (this.counsellor && (this.certificationDetails.referralCode === undefined || this.certificationDetails.referralCode === '')) {
        this.$toasted.error(self.$t('candidateProfile.certification.toastrCounsellorCodeRequired'))
        return false
      }
      if (this.referralAlc && (this.certificationDetails.alcCode !== undefined && this.certificationDetails.alcCode !== '')) {
        axios.get('r/itCertificationDetails/validateALCCode/' + this.certificationDetails.alcCode)
          .then(function (response) {
            if (response.data) {
              self.save()
            } else {
              self.$toasted.error(self.$t('candidateProfile.certification.toastrInvalidALCCode'))
            }
          })
          .catch(function (e) {
            console.error(e)
            self.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'))
          })
      } else {
        self.save()
      }
    },
    certificationSelect (itCertification) {
      if (this.noneOfAbove === false) {
        this.certificationDetails.certificationCompleted = true
      } else {
        this.certificationDetails.learnerCode = ''
        this.certificationDetails.certificationCompleted = false
        this.certificationDetails.itCertification = null
      }
    },
    getCertificationMaster () {
      var self = this
      axios.get('r/itCertificationDetails/certificates')
            .then(function (response) {
              if (response.status === 200) {
                self.certificationList = response.data
                // self.certificationList.push(self.defaultObj)
              }
            })
            .catch(function () {
              self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'))
            })
    },
    fetchUserDetails: function () {
      var self = this
      axios.get('/r/entry/getUserApplicationStatus/' + this.$store.state.candidateProfile.profileUser).then(response => {
        if (response.data !== null) {
          let profileStatus = response.data.profileStatus
          if (!profileStatus.personalDetails) {
            this.$router.push({ name: 'personalDetails' })
          } else if (!profileStatus.contactDetails) {
            this.$router.push({ name: 'address' })
          } else if (!profileStatus.educationDetails) {
            this.$router.push({ name: 'educationalDetails' })
          } else if (!profileStatus.documentDetails) {
            this.$router.push({ name: 'documentsupload' })
          } else if (!profileStatus.qualificationDetails) {
            axios.get('r/projectConfig/getAllProjectConfig')
            .then(responses => {
              if (responses.data.ocrConfig.required) {
                this.$router.push({ name: 'imageExtracter' })
              } else {
                this.$router.push({ name: 'qualificationDetails' })
              }
            })
            .catch(e => {
              console.log(e)
            })
          } else {
            this.$router.push({ name: 'profileSummary' })
          }
        }
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        console.error(e)
      })
    },
    getCertificationDetails () {
      var profileUser = this.$store.state.candidateProfile.profileUser
      var self = this
      axios.get('r/itCertificationDetails/getCertificationDetails/' + profileUser)
            .then(function (response) {
              if (response.status === 200) {
                var responseData = response.data
                if (responseData.certificationCompleted === false && responseData.itCertification.certificationName !== '') {
                  self.noneOfAbove = false
                  self.certificationDetails = response.data
                  // self.certificationDetails.itCertification = self.defaultObj
                } else if (responseData.learnerCode !== '') {
                  self.learnerCodeVerified = true
                  self.certificationDetails = response.data
                }
                if (responseData.itCertification !== undefined) {
                  if (responseData.itCertification.certificationID === 0 && responseData.itCertification.certificationName !== '') {
                    self.noneOfAbove = true
                    document.getElementById('checkIT').setAttribute('checked', 'checked')
                  }
                }
                if (responseData.referralCode !== undefined && responseData.referralCode !== '') {
                  self.certificationDetails.referralCode = responseData.referralCode
                  self.counsellor = true
                  document.getElementById('counsellor').setAttribute('checked', 'checked')
                }
                if (responseData.alcCode !== undefined && responseData.alcCode !== '') {
                  self.certificationDetails.alcCode = responseData.alcCode
                  self.referralAlc = true
                  document.getElementById('referralAlc').setAttribute('checked', 'checked')
                }
              }
            })
            .catch(function (e) {
              console.error(e)
              self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'))
            })
    },
    save: function () {
      var self = this
      if (this.certificationDetails.alcCode) {
        this.certificationDetails.alcCode = this.certificationDetails.alcCode.toUpperCase()
      }
      if (this.certificationDetails.referralCode) {
        this.certificationDetails.referralCode = this.certificationDetails.referralCode.toUpperCase()
      }
      var profileUser = this.$store.state.candidateProfile.profileUser
      if (this.noneOfAbove) {
        this.certificationDetails.itCertification = this.defaultObj
      }
      return this.$validator
        .validate()
        .then(result => {
          if (result) {
            return axios
              .post('r/itCertificationDetails/updateCertifications/' + profileUser, self.certificationDetails)
              .then(response => {
                if (response.status === 200) {
                  if (this.screenConfig.visible) {
                    this.$toasted.success(self.$t('toastr.toastrCertificationDetailsSaved'))
                  }
                  this.fetchUserDetails()
                  // this.$router.push('personalDetails')
                  return true
                }
              })
              .catch(e => {
                this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'))
                return false
              })
          } else {
            this.$toasted.error(self.$t('candidateProfile.certification.toastrSelectCertification'))
          }
          return false
        })
        .catch(e => {
          this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'))
          return false
        })
    },
    validateLearnerCode: function (scope) {
      if (this.certificationDetails.certificationCompleted === false || this.certificationDetails.itCertification === null) {
        return this.save()
      } else {
        var self = this
        return this.$validator
        .validate()
        .then(result => {
          if (result) {
            return axios.get('/r/itCertificationDetails/getlearnerdetailsusinglearnercode/' + this.certificationDetails.learnerCode + '/' + this.$store.state.candidateProfile.profileUser).then(response => {
              if (response.data !== null) {
                if (response.data === 'false') {
                  this.$toasted.error(self.$t('candidateProfile.certification.toastrLearnerCodeInvalid'))
                  return false
                } else {
                  this.learnerCodeVerified = true
                  return this.save()
                }
              }
            }).catch(e => {
              this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'))
              console.error(e)
              return false
            })
          } else {
            this.$toasted.error(self.$t('candidateProfile.certification.toastrEnterLearnerCode'))
            return false
          }
        })
        .catch(e => {
          this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'))
          return false
        })
      }
    },
    getProjectConfig () {
      axios.get('o/screenConfig/getScreenConfigByID/' + 'IT_CERTIFICATION').then(response => {
        this.screenConfig = response.data
        if (this.screenConfig.visible === false) {
          this.noneOfAbove = true
          this.nextTabFunc()
        } else {
          this.getCertificationDetails()
        }
      }).catch(function (e) {
        console.error(e)
      })
    }
  },
  created: function () {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' })
    } else {
      this.getProjectConfig()
      this.getCertificationMaster()
    }
  }
}
</script>
<style lang='scss'>
.uppercase{
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/registration/itCertification.vue